import React from 'react';

import type { DrawReactComponentProps } from '@aline/common';

export function MouseCursorOverlay({
  cursor,
  height,
  width,
}: DrawReactComponentProps['MouseCursorOverlay']) {
  return <div style={{ cursor, height, width }} />;
}
